var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-skeleton",style:(_vm.skeletonStyle),attrs:{"aria-busy":"true","aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }